import { render, staticRenderFns } from "./HowtoScreen.vue?vue&type=template&id=7a51f387&scoped=true&lang=pug&"
import script from "./HowtoScreen.vue?vue&type=script&lang=js&"
export * from "./HowtoScreen.vue?vue&type=script&lang=js&"
import style0 from "./HowtoScreen.vue?vue&type=style&index=0&id=7a51f387&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51f387",
  null
  
)

export default component.exports